import assign from 'lodash/assign';

import ClusterSettingConstants from 'app/shared/constants/ClusterSettingConstants';
// @ts-ignore
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import ErrorConstants from 'app/shared/constants/ErrorConstants';
import StringConstants from 'app/shared/constants/StringConstants';
import ValueConstants from 'app/shared/constants/ValueConstants';

const constants = assign(
    {},
    ClusterSettingConstants,
    DispatchConstants,
    ErrorConstants,
    StringConstants,
    ValueConstants
);

export default constants;
